// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-list {
  min-height: 60px;
  border-radius: 4px;
  overflow: hidden;
  display: block;
  height: 100%;
}

.example-box {
  padding: 10px 10px 5px 10px;
  border: solid 1px #ccc;
  color: rgba(236, 236, 236, 0.87);
  border-radius: 2px;
  cursor: move;
  font-size: 14px;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.btn-add {
  background-color: rgb(206, 206, 206);
}

.column-header {
  border: 1px solid rgb(207, 207, 207);
}

.page-title {
  margin-top: 25px;
  margin-bottom: 25px;
  color: #104a64;
  font-size: 2.3rem;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center;
  align-items: center;
  flex: 1 1 0%;
}

.toolbar {
  display: flex;
  width: 100%;
  height: 7%;
  height: 6%;
}

.file-manager-open {
  display: flex;
  flex-flow: column;
  flex: 0 0 25%;
  min-width: 382px;
  max-width: 500px;
  position: relative;
  background: var(--chat-sidemenu-bg-color);
  height: 107%;
  border-top-left-radius: var(--chat-container-border-radius);
  border-bottom-left-radius: var(--chat-container-border-radius);
  border-right: 1px solid #e1e4e8;
}

.file-manager-close {
  display: none;
  width: 346%;
  height: 100vh;
  border-right-width: 1px solid;
  margin-right: 13px;
}

.kanban {
  width: 100%;
}

.active::ng-deep a {
  color: white;
}

.mat-mdc-icon-button ::ng-deep {
  width: auto;
}

.cursor::ng-deep {
  cursor: pointer;
}

.font-size {
  font-size: 122%;
}

.list-group-item.active ::ng-deep {
  background-color: #104A64;
  border-color: #104A64;
}

.kanbantitle {
  width: 150px;
  margin-left: 38px;
  text-align: center;
}

@media (max-width: 1486px) {
  .kanbantitle {
    margin-left: -15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+kanban/see-kanban/see-kanban.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAAJ;;AAGE;EACE,2BAAA;EACA,sBAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAAJ;;AAIE;EACE,sBAAA;EACA,kBAAA;EACA,qHAAA;AADJ;;AAME;EACE,UAAA;AAHJ;;AAME;EACE,sDAAA;AAHJ;;AAME;EACE,YAAA;AAHJ;;AAME;EACE,sDAAA;AAHJ;;AAME;EACE,oCAAA;AAHJ;;AAME;EACE,oCAAA;AAHJ;;AAME;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACF,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAHF;;AAKE;EACE,aAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AAFJ;;AAKE;EAOE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,2DAAA;EACA,8DAAA;EACA,+BAAA;AARJ;;AAWE;EAEE,aAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;AATJ;;AAYE;EACE,WAAA;AATJ;;AAgBI;EACE,YAAA;AAbN;;AAkBI;EACE,WAAA;AAfN;;AAmBE;EACE,eAAA;AAhBJ;;AAmBE;EACE,eAAA;AAhBJ;;AAoBI;EACE,yBAAA;EACA,qBAAA;AAjBN;;AAqBE;EACE,YAAA;EAAY,iBAAA;EAAkB,kBAAA;AAhBlC;;AAmBE;EACA;IACE,kBAAA;EAhBF;AACF","sourcesContent":["\r\n  .example-list {\r\n    min-height: 60px;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    display: block;\r\n    height: 100%;\r\n  }\r\n  \r\n  .example-box {\r\n    padding: 10px 10px 5px 10px;\r\n    border: solid 1px #ccc;\r\n    color: rgba(236, 236, 236, 0.87);\r\n    border-radius: 2px;\r\n    cursor: move;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  \r\n  .cdk-drag-preview {\r\n    box-sizing: border-box;\r\n    border-radius: 4px;\r\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\r\n                0 8px 10px 1px rgba(0, 0, 0, 0.14),\r\n                0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n  }\r\n  \r\n  .cdk-drag-placeholder {\r\n    opacity: 0;\r\n  }\r\n  \r\n  .cdk-drag-animating {\r\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n  }\r\n  \r\n  .example-box:last-child {\r\n    border: none;\r\n  }\r\n  \r\n  .example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\r\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n  }\r\n  \r\n  .btn-add {\r\n    background-color: rgb(206, 206, 206);\r\n  }\r\n  \r\n  .column-header {\r\n    border: 1px solid rgb(207, 207, 207);\r\n  }\r\n  \r\n  .page-title{\r\n    margin-top: 25px;\r\n    margin-bottom: 25px;\r\n    color: #104a64;\r\n    font-size: 2.3rem;\r\n    flex-direction: row;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  place-content: center;\r\n  align-items: center;\r\n  flex: 1 1 0%;\r\n  }\r\n  .toolbar{\r\n    display: flex;\r\n    width: 100%;\r\n    height: 7%;\r\n    height: 6%;\r\n  }\r\n  \r\n  .file-manager-open{\r\n    // display: block;\r\n    // width: 30vh;\r\n    // height: 100vh; \r\n    // border-right-width: 1px solid;\r\n    // margin-right: 13px;\r\n    // background-color: $primary-color;\r\n    display: flex;\r\n    flex-flow: column;\r\n    flex: 0 0 25%;\r\n    min-width: 382px;\r\n    max-width: 500px;\r\n    position: relative;\r\n    background: var(--chat-sidemenu-bg-color);\r\n    height: 107%;\r\n    border-top-left-radius: var(--chat-container-border-radius);\r\n    border-bottom-left-radius: var(--chat-container-border-radius);\r\n    border-right: 1px solid #e1e4e8;\r\n  }\r\n  \r\n  .file-manager-close{\r\n  \r\n    display: none;\r\n    width: 346%;\r\n    height: 100vh; \r\n    border-right-width: 1px solid;\r\n    margin-right: 13px;\r\n  }\r\n  \r\n  .kanban{\r\n    width: 100%;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  .active::ng-deep{\r\n    a{\r\n      color:white\r\n    }\r\n  }\r\n\r\n  .mat-mdc-icon-button{\r\n    ::ng-deep{\r\n      width:auto;\r\n    }\r\n  }\r\n  \r\n  .cursor::ng-deep{\r\n    cursor: pointer;\r\n  }\r\n\r\n  .font-size{\r\n    font-size: 122%;\r\n  }\r\n\r\n  .list-group-item.active{\r\n    ::ng-deep{\r\n      background-color: #104A64;\r\n      border-color: #104A64;\r\n    }\r\n  }\r\n\r\n  .kanbantitle{\r\n    width:150px;margin-left: 38px;text-align: center;\r\n  }\r\n\r\n  @media (max-width: 1486px) {\r\n  .kanbantitle{\r\n    margin-left: -15px;\r\n  }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
